import React from 'react';
import ButtonPrimary from '../../../../../../Common/Button/Primary/ButtonPrimary';
import { useNavigate } from 'react-router-dom';

interface Props {
  buttonLabel: string
}

function GoToQuestionnaireButton({ buttonLabel }: Props) {
  const navigation = useNavigate();
  return (
    <ButtonPrimary label={buttonLabel} onClick={() => navigation('/onboarding')}/>
  )
}

export default GoToQuestionnaireButton;